import {
  ORDER_DETAILS_SUCCESS,
  SHIPPING_ESTIMATE_REQUEST,
  SHIPPING_ESTIMATE_SUCCESS,
  SHIPPING_ESTIMATE_FAIL,
  SHIPPING_ESTIMATE_RESET
} from '../constants/orderConstants';

// Reducer pour les actions générales de commande
export const orderReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_DETAILS_SUCCESS:
      return { ...state, orderDetails: action.payload };
    default:
      return state;
  }
};

export const shippingEstimateReducer = (state = {}, action) => {
  switch (action.type) {
    case SHIPPING_ESTIMATE_REQUEST:
      return { loading: true };
    case SHIPPING_ESTIMATE_SUCCESS:
      // Le payload entier { status: 'success', distance: ..., shippingFee: ... } est assigné à la clé "data"
      return { loading: false, data: action.payload }; 
    case SHIPPING_ESTIMATE_FAIL:
      return { loading: false, error: action.payload };
    case SHIPPING_ESTIMATE_RESET:
      return {};
    default:
      return state;
  }
};